import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { ValidationService } from '../validation.service';
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator, PageEvent, MatTableDataSource } from '@angular/material';
import { TimeService } from '../time.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { Subscription } from 'rxjs';
import { EventService } from '../event.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cement-load-dashboard',
  templateUrl: './cement-load-dashboard.component.html',
  styleUrls: ['./cement-load-dashboard.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('300ms ease-in', style({ transform: 'translateX(0%)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0.6 }),
        animate('200ms ease-in', style({ opacity: 0.6 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0.6 }))
      ])
    ]),

  ],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }]
})
export class CementLoadDashboardComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('acceptanceConfirm', { static: true }) acceptanceConfirm: TemplateRef<any>;

  displayedColumns: string[] = [
    "#",
    "load",
    "customer",
    "material",
    "allocated",
    "driver",
    "shipment",
    "deadlines",
    "shipper"
  ];
  allocationColumns: string[] = ['slno', 'requested', 'accepted', 'cancelled', 'deadline', 'assigned', 'action'];
  dataSource = new MatTableDataSource<Element>();
  showLoader = false;
  ordersArray: any = [];
  orders: any = [];
  Organisations: any[];
  showStatusTab = 0;
  showOrderDetailsView = 0;
  allocationDataSource: any;
  allocTable: any;
  selectedOrderData: any;
  allocationArray = [];
  created_date = '';
  carrierId: Subscription;
  totalOrders = 0;
  loadsFilter: any = {
    limit: 0,
    skip: 0,
  };
  accepted_plan: any;
  selectedLoadIDs: string[];
  acceptanceConfirmDialogRef: MatDialogRef<any>;

  constructor(
    private http: HttpService,
    public timeService: TimeService,
    private events: EventService,
    private snackBar: SnackbarService,
    private time: TimeService,
    private valid: ValidationService,
    private dialog: MatDialog,
    private router: Router) { }

  ngOnInit() {

    this.getOrders()
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getOrders()
      },
      (err: any) => {
        console.log('Err ::', err);
      }
    );
  }

  getOrders(filters: any = {}) {
    filters.limit = this.paginator.pageSize || 25;
    filters.skip = this.paginator.pageIndex * (this.paginator.pageSize || filters.limit);
    this.http.get("loadCements", filters).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.ordersArray = data.data.loads;
          this.totalOrders = data.data.count;
          this.orders = [];

          const childrenIdArray = [];
          const childrenWithParentIdArray = [];

          this.ordersArray.map((element: any) => {
            element.children.map((e: any) => {
              childrenIdArray.push(e);
            })
          });

          this.ordersArray.map((element: any) => {
            if (element.children && element.children.length > 0) {
              childrenWithParentIdArray.push({
                parentId: element._id,
                childrenId: element.children
              })
            }
          })

          this.ordersArray.forEach((element: any) => {
            const temp: any = {};

            //Load Details
            temp._id = element._id;
            temp.load = element.loads && element.loads.length > 0 ? element.loads[0].LIN : '';
            temp.load_id = element.loads && element.loads.length > 0 ? element.loads[0]._id : '';
            temp.SONo = (element.loads && element.loads.length > 0
              && element.loads[0].plan && element.loads[0].plan.length > 0
              && element.loads[0].plan[0].so) ? element.loads[0].plan[0].so : '';
            temp.created = (element.created_at) ? this.timeService.utcToist(element.created_at, 'dd-MMM-yy HH:mm a') : '--';
            temp.plan_date =
              (element.loads && element.loads.length > 0
                && element.loads[0].plan && element.loads[0].plan.length > 0
                && element.loads[0].plan[0].date) ?
                this.timeService.utcToist(element.loads[0].plan[0].date, 'dd-MMM-yy HH:mm a') : '--';
            temp.material = (element.loads && element.loads.length > 0
              && element.loads[0].material) ? element.loads[0].material : '';

            //Allcoated
            temp.approved = element.approved;
            temp.allocated_weight = element.allocated_weight ? element.allocated_weight : 0;
            temp.shipperId = element.shipper && element.shipper._id ? element.shipper._id : '';
            //Accepted
            temp.accepted = element.accepted_status ? element.accepted_status : false;
            temp.acceptanceDeadlineDate = element.acceptance_deadline ? this.timeService.utcToist(element.acceptance_deadline, 'dd-MMM-yy') : '--';
            temp.acceptanceDeadlineTime = element.acceptance_deadline ? this.timeService.utcToist(element.acceptance_deadline, 'HH:mm a') : '--';

            //Assigned
            temp.assigned = element.assigned_status ? element.assigned_status : false;
            temp.assignmentDeadlineDate = element.assignment_deadline ? this.timeService.utcToist(element.assignment_deadline, 'dd-MMM-yy') : '--';
            temp.assignmentDeadlineTime = element.assignment_deadline ? this.timeService.utcToist(element.assignment_deadline, 'HH:mm a') : '--';

            //Customer & Shipper & Vehicle Type
            temp.customer = (element.loads && element.loads.length > 0
              && element.loads[0].customer) ? element.loads[0].customer : {};
            temp.shipper = element.shipper ? element.shipper : {};
            temp.vehicle_type = element.vehicle_type ? element.vehicle_type : '';
            temp.vehcile_type_rate = (element.loads && element.loads.length > 0
              && element.loads[0].route && element.loads[0].route.rates && element.loads[0].route.rates[element.vehicle_type]) ? 
               `₹${element.loads[0].route.rates[element.vehicle_type]}` : '-';

            // Driver Details
            temp.driverName = element.driver && element.driver.name ? element.driver.name : '';
            temp.driverMobile = element.driver && element.driver.mobile ? element.driver.mobile : '';
            temp.vehicleNo = element.driver && element.driver.vehicle_no ? element.driver.vehicle_no : '';

            //Shipment
            temp.shipment = element.shipment ? element.shipment : '';

            // Parent & Children Indication
            temp.isParent = element.children && element.children.length > 0 ? true : false;
            temp.isChildren = element._id ? childrenWithParentIdArray.some(obj => obj.childrenId.includes(element._id)) : false;

            const combinedIds = childrenWithParentIdArray.find((obj: any) => obj.childrenId.includes(element._id) || obj.parentId.includes(element._id));
            temp.parentWithChildren = combinedIds && combinedIds.childrenId && combinedIds.childrenId.length > 0 ? [combinedIds.parentId, ...combinedIds.childrenId] : [element._id];

            temp.children = element.children ? element.children : [];

            //Shipper ID (Dedicated To)
            temp.shipperId = (element.loads && element.loads.length > 0
              && element.loads[0].shipper) ? element.loads[0].shipper._id : '';

            this.orders.push(temp);
          });

          this.showLoader = false;
          if (!this.dataSource) {
            this.dataSource = new MatTableDataSource(this.orders);
          } else {
            this.dataSource = new MatTableDataSource(this.orders);
          }
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, "", "err");
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  };

  formatTime(time) {
    return this.time.toShortDateTime(time, 'dd-MMM-yyyy');
  };

  openAcceptanceConfirmDialog(element: any) {
    if(element.accepted){
      this.snackBar.openSnackBar('Load already accepted', '', 'err');
      return;
    };

    const combinedIds = element.parentWithChildren;
    this.selectedLoadIDs = combinedIds;
    this.acceptanceConfirmDialogRef = this.dialog.open(this.acceptanceConfirm, {
      panelClass: 'acceptance-confirm-dialog',
      width: '500px',
      height: '160px',
    });
  }

  closeAcceptanceConfirmDialog() {
    if (this.acceptanceConfirmDialogRef) {
      this.acceptanceConfirmDialogRef.close();
      this.acceptanceConfirmDialogRef = null;
      this.selectedLoadIDs = [];
    }
  }

  acceptLoad() {
    let data = {
      load_allocation_ids: this.selectedLoadIDs,
    }

    this.http.post('loadCements/accept', data).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar('Load Accepted Successfully', '');
          this.showStatusTab = 0;
          this.closeAcceptanceConfirmDialog();
          this.getOrders();
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  };

  pageNavigate(event: PageEvent) {
    this.loadsFilter.limit = event.pageSize;
    this.loadsFilter.skip = event.pageIndex * event.pageSize;
    this.getOrders();
  }

  openAssignModal(data: any) {
    const loadData = {
      is_cement: data.shipperId === "66cb78e108583b1fa294d901" ? true : false,
      quantity: data.allocated_weight ? data.allocated_weight : 0,
      shipperId: data.shipperId,
      load_id: data._id ? data._id : '',
      LIN: data.load ? data.load : '',
      customer_name: data.customer && data.customer.name ? data.customer.name : '',
      customer_location: data.customer && data.customer.locality ? `${data.customer.city} - ${data.customer.locality}` : '',
      materials_id: data.materials_id ? data.materials_id : '',
      materials: data.material ? data.material : '',
      vehicle_type: data.vehicle_type ? data.vehicle_type : '',
    };
    this.router.navigate(['loadDashboard/assign'], {
      state: { loadData: loadData }
    });
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }
}
